import { always, cond, T, pathOr, isEmpty, flatten } from 'ramda';
import { LOGIN_ROOT } from "src/route_constants";
import { ADVISOR_DASHBOAD, oauthCallBackReturnTo, USERS_HOME } from 'src/route_constants';
import {
  ADVISOR_PROFILE_ROLES,
  APPLICANT_ROLES,
  verifyAccount,
} from 'src/services/constants/accounts';
import UserManageLoader from './UserManageLoader';
import { isNotEmpty } from 'src/utilities/hasValue';
import { unAuthenticatedUser } from 'src/utilities/storage';

/*
 * Deals with the login of an account used by whom?
 */
export const loginAccount = (
  user: any,
  history: any,
  _rememberMe: any,
  disableOauth?: any,
  advisorUsername?: any
) => {
  const userManage = new UserManageLoader()
  const applicantLink = disableOauth ? USERS_HOME : oauthCallBackReturnTo(USERS_HOME)
  const advisorLink = disableOauth ? ADVISOR_DASHBOAD : oauthCallBackReturnTo(ADVISOR_DASHBOAD)
  const rememberMe = true // TODO: This should be configurable 

  userManage.setLoggedInTime();
  return cond([
    [
      (role: any) => verifyAccount(role, APPLICANT_ROLES),
      () => {
        history.push(applicantLink, {
          user,
          rememberMe,
          advisorUsername
        })
      },
    ],
    [T, () => {
      history.push(advisorLink, {
        user,
        rememberMe,
      })
    }
      ,],
  ])(pathOr([], ['roles_id'], user));
};
/**
 *
 * @param localUser this is localStorage user data
 * @param returnTo this is returnTo url
 * @param search this current url
 * @param history this history data
 * This method redirect to based on local storage data.if user data have based on user role.
 */
export const rememberMeRedirect = (
  localUser: any,
  returnTo: any,
  history: any
) => {
  try {
    const { user = '', remember = '' } = localUser;
    const previousLoginTime = pathOr('', ['authentication_methods', 0, 'completed_at'], user)
    const userManage = new UserManageLoader()
    previousLoginTime && userManage.setLoggedInTime(new Date(previousLoginTime).getTime())
    isEmpty(returnTo)
      ? loginAccount(user, history, remember)
      : history.push(oauthCallBackReturnTo(returnTo), {
        user,
        rememberMe: remember,
      });
  } catch {
    history.push(LOGIN_ROOT);
  }
};

export const loginMagicLink = (user: any, history: any, advisorUsername: any, params?: any) => {
  const { loanType, propertyType } = params;
  const magicLinkInvite = oauthCallBackReturnTo(`/loans/invite`);
  const userManage = new UserManageLoader();
  userManage.setLoggedInTime();
  isNotEmpty(propertyType) && unAuthenticatedUser.productType.set(propertyType)
  cond([
    [
      ((role: any) => verifyAccount(role, flatten([APPLICANT_ROLES])) && isNotEmpty(loanType)),
      () =>
        history.push(oauthCallBackReturnTo('/loans'), {
          user,
          advisorUsername,
          loanType, propertyType
        })
    ],
    [
      (role: any) =>
        verifyAccount(role, flatten([ADVISOR_PROFILE_ROLES, APPLICANT_ROLES])),
      () =>
        history.push(magicLinkInvite, {
          user,
          advisorUsername
        })
    ],
    [T, always(LOGIN_ROOT)],
  ])(pathOr([], ['roles_id'], user));
};



export const handleErrorFromAPI = (errResponse: any) => {
  const errorMessage: any = pathOr(
    '',
    ['response', 'data', 'message'],
    errResponse
  );
  const defaultErrorMessage: any = "Request failed. Please try again.";
  return errorMessage || defaultErrorMessage;
}

export const handleLoginError = (errResponse: any) => {
  const formErrors: any = pathOr(
    [],
    ['response', 'data', 'errors'],
    errResponse
  );

  const message: any = "Incorrect email address and / or password. Please try again, or click 'Forgot Password' to reset it.";
  const schemaError = pathOr(message, [0, 'reason'], formErrors)
  return schemaError;
};


export const getLoginErrorData = (errResponse:any) => {
    const errorData: any = pathOr(
      {},
      ['response', 'data'],
      errResponse
    )

    return errorData
}